import { booleanAttribute, Component, input } from '@angular/core';

import { SafeHtml } from '@angular/platform-browser';
import { BspkTxt } from '../txt';
import { BspkInlineAlert } from '../inline-alert';

@Component({
  selector: 'bspk-form-field',
  imports: [BspkTxt, BspkInlineAlert],
  templateUrl: './form-field.component.html',
  styleUrl: './form-field.component.scss',
  host: {
    '[attr.data-form-field]': 'true',
  },
})
export class BspkFormField {
  readonly controlId = input.required<string>();
  readonly label = input.required<string>();
  readonly required = input(false, { transform: booleanAttribute });
  readonly errorMessage = input<string | SafeHtml>();
  readonly helperText = input<string>();
}
